<template>
  <div class="drawer-input__wrapper">
    <span style="margin-bottom: 20px;">{{ title }}</span>
    <el-input
      :min="0"
      style="margin-bottom: 20px;"
      :placeholder="label"
      v-model="value"
      :step="1">
    </el-input>
    <div class="">
      <el-button
        style="margin-right: 10px;"
        type="danger"
        @click="cancel">
        Annuler
      </el-button>
      <el-button
        style="margin-right: 10px;"
        type="success"
        @click="save">
        {{ saveButtonText }}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    defaultValue: { type: String, default: '' },
    title: { type: String, default: '' },
    label: { type: String, default: '' },
    saveButtonText: { type: String, default: '' },
  },
  data() {
    return {
      value: this.defaultValue,
    };
  },
  methods: {
    save() {
      this.$emit('onValueSaved', this.value);
      this.cancel();
    },
    cancel() {
      this.$emit('onCancel');
    },
  },
};
</script>
<style lang="stylus" scoped>
.drawer-input__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}
</style>
